module.exports = __webpack_public_path__ + "img/type--1-spans--single-lang--fr.632e8a07.jpg";